// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@rails/actiontext"
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers";

// Custom confirmation modal for P2P actions.
// Enabled per-element via data-turbo-confirm-modal="true".
Turbo.setConfirmMethod((message, element) => {
  if (element.dataset.turboConfirmModal !== "true") {
    return Promise.resolve(window.confirm(message))
  }

  const modalElement = document.querySelector('[data-controller="p2p--confirm-modal"]')
  if (!modalElement) {
    console.warn("[P2PConfirmModal] Modal container not found, falling back to window.confirm")
    return Promise.resolve(window.confirm(message))
  }

  const application = window.Stimulus
  const controller = application.getControllerForElementAndIdentifier(modalElement, "p2p--confirm-modal")

  if (!controller) {
    console.warn("[P2PConfirmModal] Controller not found, falling back to window.confirm")
    return Promise.resolve(window.confirm(message))
  }

  return controller.open({
    title: element.dataset.turboConfirmTitle || "Подтвердите действие",
    message: message,
    confirmText: element.dataset.turboConfirmConfirmText || "Принять",
    cancelText: element.dataset.turboConfirmCancelText || "Отмена",
    confirmClass: element.dataset.turboConfirmConfirmClass || "bg-green-600 hover:bg-green-700 text-white focus:ring-green-500",
    cancelClass: element.dataset.turboConfirmCancelClass || "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-200 focus:ring-gray-400"
  })
})

